import Model from '@/shared/models/plans/PlanPackage'

export default class PlanPackage extends Model {}
